import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { GovukInitService } from '../../services/govuk-init.service';
import { ApiService } from '../../services/jrni/api.service';
import { AppConfig } from '../../app.config';
import { Router } from '@angular/router';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear;
  ngOnInit() {
    this.currentYear = /\d{4}/.exec(Date())[0];
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
